import React, { Component } from 'react';
import Button from './button';

class Headlines extends Component {
  render() {
    return (
      <div className="block block__content">
        <div className={`block__content--img block__content--img--${this.props.imgside}`}>
        <img src={this.props.img} alt="solutions" />
        </div>
        <div className="block__content--content">
        <h1 className="eitx-orange">{this.props.title}</h1>
        <p className="eitx-grey">{this.props.summary}</p>
        <Button title="view" link={`/${this.props.link}`} type="secondary"/>
        </div>
      </div>
    )
  }
}

export default Headlines



// WEBPACK FOOTER //
// ./src/shared/headlines.js